import { SelectItem } from "primeng/api";

export class SaveGalleryStaffRequest {
    Id?: string;
    GalleryId?: string;
    Name?: string;
    FirstName?: string;
    LastName?: string;
    Email?: string;
    Password?: string;
    PhoneNumber?: string;
    GalleryStaffPosition?: string;
    GalleryStaffNotes?: string;
    StaffRole?: number; // 1 = Judge, 2 = Curator, 3 = Other
}

export class Permissions {
    StaffId!: string;
    Permission!: string;
    PermissionId!: string;
    children: SelectItem[] = [];
}

export class PermissionTree {
    label!: string;
    expanded?: boolean
    children: SelectItem[] = [];
    partialSelected?:boolean
}